export const GREEN_0E8476 = '#0E8476';
